import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

// services: [{ title, description, icon: JSX, route, image }]
const ServiceCard = ({ services }) => {
  const [selected, setSelected] = useState(0);
  const navigate = useNavigate();

  return (
    <StyledWrapper>
      <div className="panels-strip">
        {services.map((service, i) => (
          <div
            key={i}
            className={`panel ${selected === i ? 'active' : ''}`}
            onClick={() => setSelected(i)}
            style={{ backgroundImage: `url(${service.image})` }}
          >
            <div className="panel-overlay" />
            <div className="panel-content">
              <div className="panel-icon">{service.icon}</div>
              <h3 className="panel-title">{service.title}</h3>
              <div className="panel-detail">
                <p className="panel-desc">{service.description}</p>
                <button
                  className="panel-btn"
                  onClick={(e) => { e.stopPropagation(); navigate(service.route); }}
                >
                  Ver mas
                </button>
              </div>
            </div>
            <span className="panel-label-vertical">{service.title}</span>
          </div>
        ))}
      </div>

      <div className="selector-dots">
        {services.map((service, i) => (
          <button
            key={i}
            className={`dot-btn ${selected === i ? 'active' : ''}`}
            onClick={() => setSelected(i)}
          >
            <span className="dot-icon">{service.icon}</span>
            <span className="dot-label">{service.title}</span>
          </button>
        ))}
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .panels-strip {
    display: flex;
    width: 100%;
    flex: 1;
    min-height: 0;
    border-radius: 0;
    overflow: hidden;
    box-shadow: none;
    gap: 2px;
    background: #0a1a0f;
  }

  .panel {
    position: relative;
    flex: 0.6;
    background-size: cover;
    background-position: center;
    cursor: pointer;
    transition: flex 0.55s cubic-bezier(0.4, 0.0, 0.2, 1);
    overflow: hidden;
  }

  .panel.active {
    flex: 3.2;
  }

  .panel-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(8, 22, 12, 0.92) 0%,
      rgba(8, 22, 12, 0.50) 40%,
      rgba(8, 22, 12, 0.15) 70%,
      transparent 100%
    );
    transition: background 0.4s ease;
  }

  .panel.active .panel-overlay {
    background: linear-gradient(
      to top,
      rgba(8, 22, 12, 0.88) 0%,
      rgba(8, 22, 12, 0.35) 50%,
      transparent 100%
    );
  }

  .panel-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 28px 32px 32px;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.35s ease 0.1s;
  }

  .panel.active .panel-content {
    opacity: 1;
  }

  .panel-icon {
    margin-bottom: 10px;
  }

  .panel-icon svg {
    width: 44px;
    height: 44px;
    stroke: #7fd9a8;
    fill: none;
    stroke-width: 1.5;
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.6));
  }

  .panel-title {
    font-size: 1.6rem;
    font-weight: 800;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #e8f5ee;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.8);
    margin: 0 0 12px 0;
    white-space: nowrap;
  }

  .panel-detail {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.45s ease 0.2s, opacity 0.4s ease 0.25s;
  }

  .panel.active .panel-detail {
    max-height: 200px;
    opacity: 1;
  }

  .panel-desc {
    font-size: 0.92rem;
    line-height: 1.65;
    color: rgba(200, 240, 220, 0.88);
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
    margin: 0 0 18px 0;
  }

  .panel-btn {
    display: inline-block;
    padding: 9px 26px;
    border: 2px solid rgba(120, 210, 160, 0.75);
    border-radius: 6px;
    background: rgba(40, 90, 60, 0.45);
    color: #c8f0d8;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background 0.25s, border-color 0.25s, color 0.25s;
    backdrop-filter: blur(6px);
  }

  .panel-btn:hover {
    background: rgba(60, 140, 90, 0.65);
    border-color: #9de8bf;
    color: #fff;
  }

  .panel-label-vertical {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    writing-mode: vertical-rl;
    text-orientation: mixed;
    transform: rotate(180deg);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: rgba(220, 245, 230, 0.85);
    pointer-events: none;
    opacity: 1;
    transition: opacity 0.25s ease;
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.7);
    z-index: 2;
  }

  .panel.active .panel-label-vertical {
    opacity: 0;
  }

  .selector-dots {
    display: flex;
    justify-content: center;
    gap: 28px;
    margin-top: 0;
    padding: 16px 0;
    background: rgba(8, 22, 12, 0.55);
    backdrop-filter: blur(8px);
    flex-shrink: 0;
  }

  .dot-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px 16px;
    border-bottom: 2px solid transparent;
    transition: border-color 0.3s, transform 0.2s;
  }

  .dot-btn.active {
    border-bottom-color: #5dba85;
    transform: translateY(-3px);
  }

  .dot-icon svg {
    width: 28px;
    height: 28px;
    stroke: rgba(180, 225, 200, 0.6);
    fill: none;
    stroke-width: 1.5;
    transition: stroke 0.3s;
  }

  .dot-btn.active .dot-icon svg {
    stroke: #7fd9a8;
  }

  .dot-label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: rgba(180, 220, 195, 0.6);
    transition: color 0.3s;
  }

  .dot-btn.active .dot-label {
    color: #a8e8c4;
  }

  @media (max-width: 768px) {
    /* Mobile: vertical accordion - panels fill full height with flex */
    .panels-strip {
      flex-direction: column;
      gap: 0;
      overflow: hidden;
      height: 100%;
    }

    .panel {
      flex: 1;
      overflow: hidden;
      transition: flex 0.5s cubic-bezier(0.4, 0.0, 0.2, 1);
      border-bottom: 1px solid rgba(255,255,255,0.08);
    }

    .panel.active {
      flex: 5;
    }

    /* On mobile, show title row always visible on collapsed panels */
    .panel-label-vertical {
      writing-mode: horizontal-tb;
      transform: none;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      display: flex;
      align-items: center;
      padding: 0 24px;
      gap: 14px;
      font-size: 0.9rem;
      letter-spacing: 2px;
      background: rgba(8, 22, 12, 0.45);
    }

    .panel.active .panel-label-vertical {
      opacity: 0;
      pointer-events: none;
    }

    .panel-content {
      padding: 20% 24px 28px;
    }

    .panel-title {
      font-size: 1.3rem;
    }

    .selector-dots {
      display: none;
    }
  }

`;

export default ServiceCard;
